/**
 * <s-scroll-state> — sets `data-scrolled` on itself once the page scrolls past `data-offset`
 * pixels (default 8), so CSS can switch the overlay header from translucent to solid.
 */
class SScrollState extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const offset = Number(this.dataset.offset ?? 8);
    const update = () => {
      this.#frame = 0;
      this.toggleAttribute('data-scrolled', window.scrollY > offset);
    };
    update();
    window.addEventListener(
      'scroll',
      () => {
        if (!this.#frame) this.#frame = requestAnimationFrame(update);
      },
      { passive: true, signal: this.#ac.signal },
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#frame) cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-scroll-state')) customElements.define('s-scroll-state', SScrollState);
